import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { translations } from "../translations";
import {
  Settings,
  History,
  LayoutDashboard,
  LogOut,
  Globe,
  UserCog,
  Wallet,
} from "lucide-react";

// Custom CSS for dropdown
const dropdownStyle = {
  zIndex: 9999,
  position: 'absolute'
};

function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [homeBtnHide, sethomeBtnHide] = useState(true);
  const { language, changeLanguage } = useLanguage();

  useEffect(() => {
    if (localStorage.getItem("token")) {
      return sethomeBtnHide(false);
    }
  }, [location.pathname]);

  // function getName() {
  //   const email = localStorage.getItem("email");
  //   return email ? email.split("@")[0] : "";
  // }

  function signOut() {
    // Clear all authentication related items
    localStorage.removeItem("id");
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    localStorage.removeItem("data");
    localStorage.removeItem("targetSpending");
    localStorage.removeItem("incomeData");
    localStorage.removeItem("savingsGoal");
    localStorage.removeItem(
      "firebase:host:expanse-tracker-e6806-default-rtdb.europe-west1.firebasedatabase.app"
    );

    // Clear settings related items 
    localStorage.removeItem("language");

    window.location.href = "/";
  }

  const t = (key) => translations[language][key] || key;

  const toggleLanguage = () => {
    const newLang = language === "en" ? "ar" : "en";
    changeLanguage(newLang);
    window.location.reload();
  };

  return (
    <Navbar className="navbar-styling mb-3 py-3 shadow" sticky="top" style={{ zIndex: 1030 }}>
      <Container>
        <Link
          className="nav-title me-0 text-primary fs-6 fw-bold text-decoration-none"
          to="/home"
        >
          {t("expenseTracker")}
        </Link>
        <div className="d-flex align-items-center">
          {!homeBtnHide && (
            <>
              <Dropdown>
                <Dropdown.Toggle
                  variant="link"
                  id="dropdown-basic"
                  className="text-decoration-none text-secondary d-flex align-items-center gap-2"
                >
                  <UserCog size={20} className="text-success" />
                  <i>{language === "en" ? "Profile" : "الملف"}</i>
                </Dropdown.Toggle>

                <Dropdown.Menu style={dropdownStyle}>
                  <Dropdown.Item
                    onClick={() => navigate("/settings")}
                    className="d-flex align-items-center gap-2"
                  >
                    <Settings size={16} />
                    {t("settings")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navigate("/history")}
                    className="d-flex align-items-center gap-2"
                  >
                    <History size={16} />
                    {t("history")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navigate("/income-history")}
                    className="d-flex align-items-center gap-2"
                  >
                    <Wallet size={16} />
                    {t("incomeHistory")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navigate("/dashboard")}
                    className="d-flex align-items-center gap-2"
                  >
                    <LayoutDashboard size={16} />
                    {t("dashboard")}
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    onClick={signOut}
                    className="text-danger d-flex align-items-center gap-2"
                  >
                    <LogOut size={16} />
                    {t("signOut")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={toggleLanguage}
                className="d-flex align-items-center gap-2"
              >
                <Globe size={16} />
                {language === "en" ? "ع" : "E"}
              </Button>
            </>
          )}
        </div>
      </Container>
    </Navbar>
  );
}

export default NavBar;
